import React from 'react';
import { useBrand } from '../../../app/config/brand';
import { Icons } from '../../icons/Icons';

interface SidebarNavItemProps {
  item: { id: string; label: string; icon: string; primary?: boolean; action?: string };
  isActive: boolean;
  isCollapsed: boolean;
  onClick: () => void;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({ item, isActive, isCollapsed, onClick }) => {
  const brand = useBrand();
  const IconComponent = Icons[item.icon] || Icons.Document;

  // Special styling for primary (Place New Order) button
  if (item.primary) {
    return (
      <button
        onClick={onClick}
        className="w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-all hover:opacity-90 mb-4"
        style={{ backgroundColor: brand.colors.primaryAction, color: brand.colors.onPrimary }}
        title={isCollapsed ? item.label : undefined}
      >
        <IconComponent className="w-5 h-5 shrink-0" />
        {!isCollapsed && <span>{item.label}</span>}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all relative group"
      style={{
        backgroundColor: isActive ? brand.colors.sidebarHover : 'transparent',
        color: isActive ? 'white' : brand.colors.sidebarText,
      }}
      title={isCollapsed ? item.label : undefined}
    >
      {isActive && (
        <div
          className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 rounded-r"
          style={{ backgroundColor: brand.colors.sidebarActive }}
        />
      )}
      <IconComponent className="w-5 h-5 shrink-0" />
      {!isCollapsed && <span className="text-sm">{item.label}</span>}

      {/* Tooltip on hover when collapsed */}
      {isCollapsed && (
        <div className="absolute left-full ml-2 px-2 py-1 rounded-sm text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50"
          style={{ backgroundColor: brand.colors.secondary, color: 'white' }}>
          {item.label}
        </div>
      )}
    </button>
  );
};
